import * as _ from 'lodash-es'
import axios from 'axios'

const state = {
  uploadedFiles: [],
  status: undefined,
}

const mutations = {
  SET_UPLOADED_FILES(state, files) {
    state.uploadedFiles = files
  },
  SET_STATUS(state, status) {
    state.status = status
  },
}

const actions = {
  async fetchDocuments({ commit, dispatch, state }) {
    try {
      const response = await axios.get('/api/document')
      commit('SET_UPLOADED_FILES', response.data)
      return response.data
    } catch (err) {
      console.log('Error fetching documents', err)
      return err
    }
  },

  async uploadDocument({ commit, dispatch, state }, formData) {
    try {
      const response = await axios.post('/api/document/', formData)
      return response
    } catch (err) {
      console.log('Error uploading document', err)
      return err
    }
  },

  async downloadDocument({ commit, dispatch, state }, doc) {
    try {
      const response = await axios.get('/api/document/' + doc.id, { responseType: 'blob' })
      let blob = new Blob([response.data], { type: response.data.type })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = doc.filename
      link.click()
    } catch (err) {
      console.log('Error downloading document', err)
    }
  },

  async deleteDocument({ commit, dispatch, state }, fileId) {
    try {
      const response = await axios.delete('/api/document/' + fileId)
      await dispatch('fetchDocuments')
      return response
    } catch (err) {
      console.log('Error downloading document', err)
      return err
    }
  },

  async updateDocumentMetadata({ commit, dispatch, state }, doc) {
    try {
      const response = await axios.post('/api/document/metadata', doc)
      await dispatch('fetchDocuments')
      return response
    } catch (err) {
      console.log('Error uploading document', err)
      return err
    }
  },

  setStatus({ commit }, status) {
    commit('SET_STATUS', status)
  },
}

const getters = {}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
